import * as React from "react";
import Context from "./Context";
import CommentModel from "../models/CommentModel";
import RatingModel from "../models/RatingModel";
import CommentRating from "./CommentRating";
import "./CommentFoot.styl";
import CommentReplyButton from "./CommentReplyButton";

export default class CommentFoot extends React.Component<{
    comment: CommentModel;
    rating: RatingModel | null;
}> {

    public render(): React.ReactNode {
        const comment = this.props.comment;
        return (
            <Context.Consumer>
                {({dispatch, translate}) => (
                    <div className="Discussion-CommentFoot-Root">
                        <div className="Discussion-CommentFoot-Reply">
                            <CommentReplyButton comment={comment}/>
                        </div>
                        <div className="Discussion-CommentFoot-Rating">
                            <CommentRating comment={this.props.comment} rating={this.props.rating}/>
                        </div>
                    </div>
                )}
            </Context.Consumer>
        );
    }

}